export default __webpack_public_path__ + "static/media/XL.68248328.png";